<!--
 * @Author: 孙照
 * @LastEditTime: 2023-10-10 15:07:41
 * @Description: 当前充电情况
 * @FilePath: \sheyang\src\module\overview\stationChargeModal\components\currentCharging.vue
-->
<template>
  <div class="current-charging" @click="handleGoCpop">
    <pub-info-title :title="'当前充电情况'" :is-modal-long="true" />
    <div class="park-container">
      <img class="animation-png" src="@/assets/images/apng/bigCarStation.png" alt="">
    </div>
    <div class="infomation">
      <div class="charging_condition_data">
          <div
            v-for="(item, index) in chargingConditionData"
            :key="index"
            class="item_content"
          >
            <div class="item_content_box">
              <p :class="'fgc' + (index + 1)">{{ item.value }}</p>
              <img class="img-style" :src="item.url" alt="" />
              <span class="title">{{ item.title }}</span>
            </div>
            <div class="item_content_circle_box">
              <simgle-circle :info="item" />
              <p>{{ item.baifenbi | toFixed }}%</p>
            </div>
          </div>
        </div>
    </div>
    <div class="equipment-cnt-container">
      <div class="cnt-item">
        <div class="label">终端总数</div>
        <div class="cnt">{{(chargeStatus.acTotalCnt || 0) + (chargeStatus.dcTotalCnt || 0)}}</div>
      </div>
      <div class="border-inline"></div>
      <div class="cnt-item">
        <div class="label">交流枪数</div>
        <div class="cnt">{{chargeStatus.acTotalCnt || 0}}</div>
      </div>
      <div class="border-inline"></div>
      <div class="cnt-item">
        <div class="label">直流枪数</div>
        <div class="cnt">{{chargeStatus.dcTotalCnt || 0}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import pubInfoTitle from '@/components/infoTitle/index.vue';
import simgleCircle from '@/components/simgleCircle/index.vue';
import { getChargeStatus } from '@/api/stationStatistics/index';

export default {
  name: 'current-charging',
  components: {
    pubInfoTitle,
    simgleCircle,
  },
  filters: {
    // 保留两位小数
    toFixed(value) {
      return value.toFixed(2);
    },
  },
  props: {
    stationId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      chargeStatus: {},
      chargingConditionData: [
        {
          index: 0,
          title: '充电中',
          value: 0,
          url: require('@/assets/images/chargingStatistics/charging_icon.png'),
          baifenbi: 0,
        },
        {
          index: 1,
          title: '空闲',
          value: 0,
          url: require('@/assets/images/chargingStatistics/empty_icon.png'),
          baifenbi: 0,
        },
        {
          index: 2,
          title: '离线',
          value: 0,
          url: require('@/assets/images/chargingStatistics/offline_icon.png'),
          baifenbi: 0,
        },
        {
          index: 3,
          title: '故障',
          value: 0,
          url: require('@/assets/images/chargingStatistics/fault_icon.png'),
          baifenbi: 0,
        },
        {
          index: 4,
          title: '其他',
          value: 0,
          url: require('@/assets/images/chargingStatistics/other_icon.png'),
          baifenbi: 0,
        },
      ],
    };
  },
  watch: {
    stationId: {
      handler(val, oldVal) {
        if (val !== oldVal) {
          this.fecthChargeStatus(val);
        }
      },
      immediate: true,
    },
  },
  methods: {
    fecthChargeStatus(stubGroupId) {
      getChargeStatus({ stubGroupId }).then((res) => {
        this.chargingConditionData[0].value = res.data.adcCharging;
        this.chargingConditionData[0].baifenbi = res.data.adcChargingRatio * 100;
        this.chargingConditionData[1].value = res.data.adcFree;
        this.chargingConditionData[1].baifenbi = res.data.adcFreeRatio * 100;
        this.chargingConditionData[2].value = res.data.adcOffLine;
        this.chargingConditionData[2].baifenbi = res.data.adcOffLineRatio * 100;
        this.chargingConditionData[3].value = res.data.adcFault;
        this.chargingConditionData[3].baifenbi = res.data.adcFaultRatio * 100;
        this.chargingConditionData[4].value = res.data.rests;
        this.chargingConditionData[4].baifenbi = res.data.restsRatio * 100;
        this.chargeStatus = res.data;
      });
    },
    handleGoCpop() {
      window.open(process.env.VUE_APP_MANAGE);
    }
  },
};
</script>

<style lang="less" scoped>
.current-charging {
  margin-top: 20px;
  ::v-deep .pub-info-title {
    margin-bottom: 16px;
  }
  .park-container {
    width: 715px;
    height: 110px;
    position: relative;
    .animation-png {
      width: 765px;
      height: 150px;
      position: absolute;
      top: -20px;
    }
  }
  .infomation {
    display: flex;
    flex-direction: column;
    align-items: center;
    .charging_condition_data {
      width: 715px;
      box-sizing: border-box;
      padding: 0 20px;
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      .item_content {
        display: flex;
        flex-direction: column;
        align-items: center;
        .item_content_box {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 11px;
          p {
            height: 21px;
            line-height: 21px;
            font-size: 18px;
            text-align: center;
            animation: bounce-down 3.5s linear infinite;
          }
          p.fgc1 {
            color: #12fbf7;
          }
          p.fgc2 {
            color: #ffab13;
          }
          p.fgc3 {
            color: #e2e2e2;
          }
          p.fgc4 {
            color: #ff4013;
          }
          p.fgc5 {
            color: #13a1ff;
          }
          .img-style {
            width: 63px;
            height: 60px;
          }
          .title {
            font-size: 12px;
            color: #ffffff;
            margin-top: 4px;
          }
          @keyframes bounce-down {
            0% {
              -webkit-transform: translateY(15px);
            }
            50% {
              -webkit-transform: translateY(25px);
            }
            100% {
              -webkit-transform: translateY(15px);
            }
          }
        }
        .item_content_circle_box {
          width: 76px;
          height: 33px;
          padding: 6px 10px;
          display: flex;
          align-items: center;
          box-sizing: border-box;
          justify-content: space-between;
          .backgroundImage('@/assets/images/chargingStatistics/charging_condition_box.png');
          p {
            color: #ffffff;
            font-size: 12px;
          }
        }
      }
    }
  }
  .equipment-cnt-container {
    width: 100%;
    height: 66px;
    border: 2px solid;
    margin-top: 32px;
    border-image: linear-gradient(270deg, rgba(136, 220, 251, 0.18), rgba(113, 209, 249, 0.6), rgba(106, 206, 249, 0.18)) 2 2;
    //.backgroundImage('@/assets/images/chargingStatistics/charging_condition_box.png');
    display: flex;
    align-items: center;
    .cnt-item {
      flex: 1;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      .label {
        font-size: 14px;
        font-weight: 400;
        color: #CCCCCC;
        line-height: 20px;
      }
      .cnt {
        font-size: 22px;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 26px;
      }
    }
    .border-inline {
      height: 46px;
      opacity: 0.7;
      border-image: linear-gradient(180deg, rgba(113, 209, 249, 0), rgba(113, 209, 249, 1), rgba(113, 209, 249, 0)) 2 2;
      border-left: 2px solid;
    }
  }

}
</style>
